<template>
  <div>
    <div v-for="item in history" :key="item.id">
      <v-card
        class="mx-auto"
        light
        max-width="400"
        :style="item.type | item_color"
      >
        <v-card-title>
          <v-icon large left>
            {{ item.type | item_icon }}
          </v-icon>
          <span class="title font-weight-light">{{ item.action }}</span>
        </v-card-title>
        <v-card-text class="font-weight-bold">
          {{ item.description }}
        </v-card-text>

        <v-card-actions>
          <v-list-tile class="grow">
            <v-list-tile-avatar color="grey darken-3">
              <v-img
                class="elevation-6"
                src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
              ></v-img>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <!-- <v-list-tile-title>{{item.agent}}</v-list-tile-title> -->
              <span>{{ item.agent }}</span>
            </v-list-tile-content>

            <v-layout align-center justify-end>
              <v-icon class="mr-1">mdi-heart</v-icon>
              <span class="subheading mr-2">256</span>
              <span class="mr-1">·</span>
              <v-icon class="mr-1">mdi-share-variant</v-icon>
              <span class="subheading">45</span>
            </v-layout>
          </v-list-tile>
        </v-card-actions>
      </v-card>
      <v-divider></v-divider>
      <br />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("cs", ["history"]),
  },
  filters: {
    item_icon(value) {
      if (!value) return "";
      if (value === "cadastro") {
        return "person_add_alt_1";
      } else {
        return "emoji_emotions";
      }
    },
    item_color(value) {
      if (!value) return "";
      if (value === "cadastro") {
        return "border: 1px solid green";
      } else {
        return "border: 1px solid blue";
      }
    },
  },
};
</script>
